module.exports = __webpack_public_path__ + "static/media/Steelix_gaussian2.5c026ff6.png";